import { useAuth } from "@amazing-care/auth";
import { Button } from "@amazing-care/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@amazing-care/ui/empty";
import { LockIcon } from "lucide-react";
import { useDocumentTitle } from "@/hooks/use-document-title";

/**
 * A session exists but the account has no profile. Only Microsoft sign-ins
 * become members, so this is an account created some other way.
 */
export function NoAccess() {
  useDocumentTitle("No access");
  const { user, signOut } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <LockIcon />
          </EmptyMedia>
          <EmptyTitle>This account can't use the portal</EmptyTitle>
          <EmptyDescription>
            {user?.email ? `${user.email} is signed in, but it` : "This account"} isn't an Amazing
            Care staff account. Sign out and continue with your work Microsoft account.
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button onClick={() => signOut()}>Sign out</Button>
        </EmptyContent>
      </Empty>
    </div>
  );
}
